/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { useOrgId } from '../provider';
import { StorageModule } from '@vlinder-web/storage-module-react';
import { GET_USER_LIST } from '../../config/api/graphql';
import moment from 'moment-timezone';
import { toHeaderCase } from 'js-convert-case';
import { vappContainer } from '@/application';
import { Graphql } from '@common/graphql';
import { AppNavigatorService } from '@/AppNavigator/services';
import { apiConfig } from '@/config/apiConfig';
import { userListConfig } from '../../config/userLists.config';

const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};
export interface IUserListsMethods extends IPluginMethodMap {
  getUserListsProps(args: any): Promise<any>;
}

export class UserListsService implements IAgentPlugin {
  readonly methods: IUserListsMethods;

  constructor() {
    this.methods = {
      getUserListsProps: this.getUserListsProps.bind(this),
    };
  }

  async getUserListsProps(args: any) {
    console.log(`args in user lists service`, args);
    try {
      let gql = Graphql.withBaseUrl(apiConfig.gql.url);
      const token = loginSrv()?.getToken();
      if (token) {
        gql = gql.withHeaders({
          authentication: token,
        });
      }
      const client = gql.getClient();
      if (client) {
        const res = await client.query(GET_USER_LIST, {
          input: {
            where: [],
            limit: args?.size,
            skip: args?.offset,
            order: [
              {
                column: 'createdAt',
                direction: 'DESC',
              },
            ],
            relationFilter: {
              role: {
                where: [
                  {
                    column: 'name',
                    op: 'Equal',
                    value: ['prospective_employee'],
                  },
                ],
              },
            },
          },
        });
        if (res?.data) {
          console.log(`table data`, res);
          let _rowData = this.formatUserTable(res?.data?.getUserList?.data);
          console.log(`row data`, _rowData);
          return {
            ...userListConfig,
            ultUsers: _rowData,
            userRoles: res?.data?.getRoleList?.data,
            isEmpty: res?.data?.getUserList?.data?.length <= 0,
            // studentGroup: holderGroups,
            activePage: res?.data?.getUserList?.currentPage,
            pageSize: res?.data?.getUserList?.pageSize,
            totalCount: res?.data?.getUserList?.totalCount,
            totalPages: res?.data?.getUserList?.totalPages,
          };
        } else {
          return {
            isEmpty: true,
          };
        }
      }
    } catch (err: any) {
      console.log(`error in table data`, err);
      return {
        isEmpty: true,
      };
    }
  }

  private formatUserTable(data: any) {
    let _rowData: any =
      Array.isArray(data) &&
      data.map((item: any) => {
        return {
          id: item?.vuid,
          // status: item?.status,
          status: this.getFormattedStatus(item?.accountStatus, item?.suspended),
          name: `${toHeaderCase(item?.firstName ?? '')} ${toHeaderCase(
            item?.lastName ?? ''
          )}`,
          email: item?.email,
          dateCreated: this.formatCreatedDate(item?.createdAt),
          image: item?.image,
          verified: item?.emailVerified,
        };
      });

    return _rowData;
  }

  private formatCreatedDate(date: Date) {
    if (date) {
      return moment(date).format('LLL');
    }
  }

  private getFormattedStatus(status: string, suspended: boolean) {
    if (suspended) {
      return 'suspended';
    } else {
      switch (status) {
        case 'USER_ADDED':
          return 'created';
        case 'USER_INVITED':
          return 'invited';
        case 'USER_EMAIL_VERIFIED':
          return 'verified';
        case 'USER_VERIFIED':
          return 'verified';
        case 'USER_ACC_CREATED':
          return 'active';
        case 'WALLET_REGISTERED':
          return 'active';
        case 'SUSPENDED':
          return 'suspended';
        default:
          return '-';
      }
    }
  }
}
